module.exports = __webpack_public_path__ + "static/media/cbwg.0f54c311.png";